import { render, staticRenderFns } from "./CoreSelectInsurer.vue?vue&type=template&id=02b7e82d"
import script from "./CoreSelectInsurer.vue?vue&type=script&lang=js"
export * from "./CoreSelectInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports